module.exports = __webpack_public_path__ + "static/media/C027.41113fef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C027.jpg
// module id = 310
// module chunks = 0